export default {"src":"/_next/static/media/0xd5147bc8e386d91cc5dbe72099dac6c9b99276f5.5b08ff38.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};